import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store' // Register a global custom directive called `v-focus`

createApp(App).use(store).use(router).mount('#app')
